import { Component, Input, OnDestroy, OnInit } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { Subscription } from 'rxjs/Subscription'
import { fuseAnimations } from '../../../../core/animations'
import { AdministrationService } from '../../../services/administration.service'
import { MatTableDataSource, PageEvent } from '@angular/material'
import 'rxjs/add/operator/switchMap'
import 'rxjs/add/operator/do'
import 'rxjs/add/operator/map'
import { AdministrationResponse } from '../../../models/administration-response'
import { AdministrationModel } from '../../../models/administration.model'

@Component({
  selector: 'app-administration-list',
  templateUrl: './administration-list.component.html',
  styleUrls: ['./administration-list.component.scss'],
  animations: fuseAnimations,
})
export class AdministrationListComponent implements OnInit, OnDestroy {
  @Input() administrationResponse: AdministrationResponse
  administrations: AdministrationModel[]
  onListChanged: Subscription
  dataSource: any
  displayedColumns = ['id', 'name', 'owner', 'legal_form', 'created', 'stopped']
  isLoading = false

  constructor(private route: ActivatedRoute, private administrationService: AdministrationService) {}

  ngOnInit() {
    this.onListChanged = this.administrationService.onAdministrationsChanged
      .do(() => {
        this.dataSource = undefined
      })
      .filter(administrationResponse => !!administrationResponse)
      .map((administrationResponse: AdministrationResponse) => {
        this.isLoading = false
        this.administrationResponse = administrationResponse
        this.mapAdministrationResponse(administrationResponse)
      })
      .subscribe()

    this.mapAdministrationResponse(this.administrationResponse)
  }

  ngOnDestroy() {
    this.onListChanged.unsubscribe()
  }

  mapAdministrationResponse(administrationResponse: AdministrationResponse) {
    const adminArray = []

    for (const row of administrationResponse.items) {
      adminArray.push(row)
    }

    this.administrations = adminArray
    this.dataSource = new MatTableDataSource<AdministrationModel>(this.administrations)
  }

  /**
   *
   * @param administration
   */
  readAdmin(administration) {
    // Set current admin
    this.administrationService.setCurrentAdministration(administration)
  }

  getServerData(event?: PageEvent) {
    this.administrationService.changeFilter(event)
  }
}



// WEBPACK FOOTER //
// ./src/app/main/content/administrations/administration-list/administration-list.component.ts